module.exports = __webpack_public_path__ + "static/hero-bg-cc93fa1ee17a68de5e098af4fba8c35c.jpg";